import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FiMoreVertical } from 'react-icons/fi';
import './TableActions.css';

export default function TableActions({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, right: 0 });
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  const updatePosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 8,
        right: window.innerWidth - rect.right
      });
    }
  };

  useEffect(() => {
    if (isOpen) {
      updatePosition();
      // Use capture=true for scroll to detect scroll in parent containers
      window.addEventListener('scroll', updatePosition, true);
      window.addEventListener('resize', updatePosition);
    }
    
    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [isOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      const clickedInsideDropdown = dropdownRef.current && dropdownRef.current.contains(event.target);
      const clickedInsideButton = buttonRef.current && buttonRef.current.contains(event.target);

      if (!clickedInsideDropdown && !clickedInsideButton) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="table-actions-container">
      <button 
        ref={buttonRef}
        type="button"
        className={`table-actions-trigger ${isOpen ? 'active' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <FiMoreVertical size={18} />
      </button>

      {isOpen && createPortal(
        <div 
          ref={dropdownRef}
          className="table-actions-dropdown"
          style={{ 
            top: position.top, 
            right: position.right
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child, {
                onClick: (e) => {
                  setIsOpen(false);
                  if (child.props.onClick) {
                    child.props.onClick(e);
                  }
                },
              });
            }
            return child;
          })}
        </div>,
        document.body
      )}
    </div>
  );
}
